/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import Tarjeta_Caracteristicas_Home from "../Tarjetas/Tarjeta_Caracteristicas_Home";
import ic_ingreso from '../../../../Recursos/ic_ingreso.svg'
import ic_periodico from '../../../../Recursos/ic_periodico.svg'
import ic_retiro from '../../../../Recursos/ic_retiro.svg'
import ic_incapacidad from '../../../../Recursos/ic_incapacidad.svg'
import ic_altu from '../../../../Recursos/ic_altu.svg'
import ic_confi from '../../../../Recursos/ic_confi.svg'


const Lista_Tarjeta_Caracteristicas_Home = () => {

    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={12}
            spacing={8}>

            {caracteristicas.map((caracteristica, index) => (

                <Grid2 container size={{xs: 12, sm: 6, md: 6}}>
                    <Tarjeta_Caracteristicas_Home
                        titulo={caracteristica.titulo}
                        parrafo={caracteristica.parrafo}
                        icono={caracteristica.icono}
                    />
                </Grid2>
            ))}

        </Grid2>
    )

}
export default Lista_Tarjeta_Caracteristicas_Home

const caracteristicas = [
    {
        icono: ic_ingreso,
        titulo: 'Exámen Médico Ocupacional de Ingreso',
        parrafo: 'Las evaluaciones médicas de ingreso se realizan con el fin de detectar condiciones individuales, establecer la capacidad física, mental y social de un aspirante antes de su contratación'
    },
    {
        icono: ic_periodico,
        titulo: 'Exámen Médico Ocupacional Periódico',
        parrafo: 'Las evaluaciones médicas de ingreso se realizan con el fin de detectar condiciones individuales, establecer la capacidad física, mental y social de un aspirante antes de su contratación'
    },
    {
        icono: ic_retiro,
        titulo: 'Exámen Médico Ocupacional de Retiro',
        parrafo: 'El examen de retiro se debe realizar en el momento en que el trabajador termina su contratación con la empresa.'
    },
    {
        icono: ic_incapacidad,
        titulo: 'Exámen médico Ocupacional Post-Incapacidad',
        parrafo: 'El objetivo del examen es el reintegro de los trabajadores a su actividad, sin causar perjuicios en su condición, después de la incapacidad.'
    },
    {
        icono: ic_altu,
        titulo: 'Exámenes para Trabajo en Alturas',
        parrafo: 'Realizamos evaluaciones médicas especializadas para determinar la aptitud física y mental de los trabajadores que deben desempeñarse en alturas, cumpliendo con los requisitos de seguridad establecidos.'
    },
    {
        icono: ic_confi,
        titulo: 'Exámenes para Trabajo en Espacios Confinados',
        parrafo: 'Aplicamos valoraciones médicas orientadas a garantizar que los trabajadores cuenten con las condiciones de salud necesarias para desempeñarse de forma segura en espacios confinados, minimizando riesgos laborales.'
    },

]